var React = require('react');

function SendUnactive (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m22 12-20-10 2.35 8.82 12.36 1.18-12.36 1.18-2.35 8.82z","fill":"#666","fillRule":"evenodd","key":0}),React.createElement("path",{"d":"m0 0h24v24h-24z","fill":"none","key":1})]);
}

SendUnactive.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = SendUnactive;

SendUnactive.default = SendUnactive;
